import { jsx as _jsx } from "react/jsx-runtime";
import s from './PageTitle.module.scss';
export const PageTitle = ({ children }) => _jsx("h1", { className: s.page_title, children: children });
